import styled from '@emotion/styled'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { breakWords } from '../../__styling/style-mixins'

export const StyledEmbed = styled('div')<{
    embedLink?: string
}>(({ embedLink, theme }) => {
    return {
        position: 'relative',
        clear: 'both',
        margin: calcRem(theme.margins.md, 0),
        ...breakWords,

        '&.embed iframe': {
            // DPT-1402: Unsure why this works as it's overwritten by display: block on the iframes
            // inline styles but without this it's broken
            display: 'flex',
        },
    }
})

export const StyledInstagramEmbed = styled(StyledEmbed)(({ theme }) => ({
    // So the instagram embed fits on page and is not cut DPT-2804
    [`@media (max-width: ${320 + theme.margins.md * 2}px)`]: {
        marginLeft: calcRem(-theme.margins.md),
    },
}))

export const StyledTwitterEmbed = styled(StyledEmbed)(({ theme }) => ({
    //Centres Twitter embeds DPT-3913
    '.twitter-tweet': {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}))

export const StyledFacebookEmbed = styled(StyledEmbed)(({ theme }) => ({
    // So the fb embed fits on page and is not cut DPT-2804
    textAlign: 'center',
    '& iframe': {
        width: 'auto !important',
        margin: 'auto',
    },
    [`@media (min-width: 660px)`]: {
        '& iframe': {
            minWidth: '480px !important',
        },
    },
    [`@media (max-width: 659px)`]: {
        '& iframe': {
            minWidth: `calc(100% - 2 * ${theme.margins.md}px) !important`,
        },
    },
}))

export const StyledEmbedlyFallback = styled('div')({
    padding: calcRem(5),
    div: {
        marginBottom: calcRem(10),
    },
    '.embed-fallback-desc': {
        fontSize: calcRem(14),
    },
    '.embed-fallback-url': {
        fontSize: calcRem(14),
        color: '#1a95b3',
    },
})
